import React from 'react';
import Modal from '../../../../Presentation/components/ui/Modal';
import {Role} from '../../models/role.model';
import {useRolePermissionsModal} from '../../hooks/useRolePermissionsModal';
import {RolePermissionsModalContent} from '../shared/RolePermissionsModalContent';

interface RolePermissionsModalProps {
  open: boolean;
  onClose: () => void;
  role: Role | null;
  onPermissionsUpdated?: () => void;
}

/**
 * Clean, simplified RolePermissionsModal component
 * Business logic extracted to custom hook for better separation of concerns
 */
export const RolePermissionsModal: React.FC<RolePermissionsModalProps> = ({
  open,
  onClose,
  role,
  onPermissionsUpdated
}) => {
  const {
    selectedPermissions,
    assigning,
    loadingRolePermissions,
    permissionsLoading,
    allPermissions,
    handlePermissionToggle,
    handleSelectAll,
    handleDeselectAll,
    handleDeselectCategory,
    handleSavePermissions,
    getResourceDisplayName,
    getActionDisplayName,
    hasChanges,
    permissionsByCategory
  } = useRolePermissionsModal({open, role});

  const handleSave = async () => {
    await handleSavePermissions();
    onPermissionsUpdated?.();
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  if (!role) {
    return null;
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={`إدارة صلاحيات الدور: ${role.displayName || role.name}`}
      width="max-w-6xl"
    >
      <RolePermissionsModalContent
        role={role}
        selectedPermissions={selectedPermissions}
        allPermissions={allPermissions}
        hasChanges={hasChanges}
        assigning={assigning}
        permissionsLoading={permissionsLoading}
        loadingRolePermissions={loadingRolePermissions}
        permissionsByCategory={permissionsByCategory}
        onPermissionToggle={handlePermissionToggle}
        onSelectAll={handleSelectAll}
        onDeselectAll={handleDeselectAll}
        onDeselectCategory={handleDeselectCategory}
        getResourceDisplayName={getResourceDisplayName}
        getActionDisplayName={getActionDisplayName}
        onCancel={handleCancel}
        onSave={handleSave}
      />
    </Modal>
  );
};
